import { useParamsSearch } from '@anytag/shared-hooks';
import { AccountFilterSearchSchemaType } from '../schemaTypes';

export const useAccountsFilter = () => useParamsSearch<AccountFilterSearchSchemaType>();
